import styled from 'styled-components';

const IconBox = styled.span`
  display: inline-flex;
  align-self: center;
`;

export default IconBox;
